import { useLang, Lang } from './LanguageContext';

/**
 * Dizionario delle etichette fisse dell'interfaccia (non gestite dal CMS): menu, footer, moduli,
 * calendario, esiti prenotazione, ecc. I testi di contenuto delle pagine sono invece bilingui
 * tramite il CMS (valore IT + valore EN per chiave).
 */
export const UI: Record<Lang, Record<string, string>> = {
  it: {
    // nav
    'nav.home': 'Home', 'nav.storia': 'Storia', 'nav.tour': 'Tour', 'nav.gare': 'Gare',
    'nav.iscrizioni': 'Iscrizioni', 'nav.contatti': 'Contatti', 'nav.book': 'Prenota',
    // footer
    'footer.moto': 'Moto Club', 'footer.eventi': 'Eventi', 'footer.contatti': 'Contatti',
    'footer.link.convenzioni': 'Convenzioni', 'footer.link.sponsor': 'Sponsor',
    'footer.tagline': 'Adventure since 2020 · Made in Sardegna',
    'footer.privacy': 'Privacy Policy', 'footer.termini': 'Termini e Condizioni', 'footer.login': 'Login',
    // page hero titoli / crumb
    'crumb.home': 'Home', 'crumb.prenotazione': 'Prenotazione',
    'page.storia.title': 'Storia', 'page.tour.title': 'Tour', 'page.gare.title': 'Gare',
    'page.iscrizioni.title': 'Iscrizioni', 'page.contatti.title': 'Contatti',
    // tour page (parti fisse)
    'tp.eyebrow': 'Enduro / Off-Road', 'tp.title': 'Scegli la tua avventura',
    'tp.lead': 'Base operativa a Olbia. Ogni tour è guidato, con assistenza e possibilità di noleggio moto.',
    'tp.included': 'Comprende', 'tp.notIncluded': 'Non comprende', 'tp.book': 'Prenota questo tour',
    'tp.none': 'I tour saranno presto disponibili. Contattaci al {phone}.',
    'tp.prenota.eyebrow': 'Prenota il tour', 'tp.prenota.title': 'Scegli date\ne parti',
    'tp.prenota.lead': 'Seleziona il tour, la data e il numero di persone. Ti confermiamo disponibilità e dettagli via email.',
    'tp.meta.orario': 'Orario 9:00 — 16:30', 'tp.meta.min': 'Minimo {n} persone', 'tp.meta.email': 'Conferma via email',
    'tp.price.from': 'A partire da\na persona / giorno',
    'tp.price.note': "Paghi online solo l'acconto del {deposit}% per bloccare il posto. Cancellazione gratuita fino a 3 settimane prima. Se la data è al completo entri in lista d'attesa.",
    'tp.cta.eyebrow': 'Percorsi su misura', 'tp.cta.title': 'Costruiamo\nil tuo tour',
    'tp.cta.text': 'Hai in mente un itinerario particolare? Raccontacelo: costruiamo un tour su misura per il tuo gruppo.',
    'tp.cta.phone': 'Chiama ora',
    // booking form
    'bf.tour': 'Tour', 'bf.tour.ph': '— Seleziona un tour —',
    'bf.date': 'Data disponibile', 'bf.date.ph.pick': '— Seleziona una data —',
    'bf.date.ph.none': 'Nessuna data disponibile — contattaci', 'bf.date.ph.first': 'Prima scegli un tour',
    'bf.seatsFree': 'posti liberi', 'bf.waitlist': "lista d'attesa",
    'bf.period': 'Scegli il periodo', 'bf.period.selectEnd': 'seleziona la data di fine', 'bf.days': 'giorni',
    'bf.people': 'Persone', 'bf.people.min': 'Min', 'bf.people.max': 'max', 'bf.people.part': 'partecipanti',
    'bf.level': 'Livello', 'bf.level.1': 'Amatoriale', 'bf.level.2': 'Intermedio', 'bf.level.3': 'Avanzato',
    'bf.name': 'Nome', 'bf.surname': 'Cognome', 'bf.email': 'Email', 'bf.phone': 'Telefono',
    'bf.notes': 'Note', 'bf.notes.ph': 'Esperienza, moto, richieste particolari...',
    'bf.consent': 'Acconsento al trattamento dei miei dati personali',
    'bf.submit': 'Prenota ora', 'bf.submitting': 'Invio…',
    'bf.err.period': 'Seleziona un periodo sul calendario.', 'bf.err.date': 'Seleziona una data disponibile.',
    'bf.err.consent': 'È necessario acconsentire al trattamento dei dati.',
    'bf.err.generic': "Errore durante l'invio della prenotazione.",
    'bf.result.title': 'Richiesta inviata ✓',
    'bf.result.waitlist': "Le date scelte risultano al completo: confermando dall'email entrerai in lista d'attesa e ti avviseremo appena si libera un posto.",
    'bf.prev.duration': 'Durata', 'bf.prev.people': 'persone',
    'bf.prev.total': 'Totale stimato', 'bf.prev.deposit': 'Acconto online',
    'bf.prev.waitlistNote': "Alcune giornate del periodo sono al completo: potresti entrare in lista d'attesa.",
    'bf.prev.estimate': 'Stima indicativa. Il preventivo definitivo ti verrà confermato.',
    // calendario
    'cal.legend.free': 'Disponibile', 'cal.legend.tight': "Lista d'attesa",
    'cal.loading': 'Caricamento disponibilità…', 'cal.seatsFree': 'posti liberi', 'cal.notAvailable': 'Non disponibile',
    // calendario vetrina (tutti i pacchetti)
    'cal.showcase.eyebrow': 'Calendario', 'cal.showcase.title': 'Disponibilità\ndei pacchetti',
    'cal.showcase.lead': 'Sfoglia i mesi: ogni giorno mostra i pacchetti in programma. Clicca una giornata per prenotare.',
    'cal.showcase.empty': 'Nessuna data in programma nei prossimi mesi. Contattaci per un tour su misura.',
    'cal.detail.prompt': 'Seleziona una giornata evidenziata per vedere i pacchetti disponibili.',
    'cal.detail.on': 'Pacchetti del', 'cal.pkg.full': 'Al completo', 'cal.pkg.seats': 'posti',
    'cal.pkg.book': 'Prenota', 'cal.pkg.perday': 'a persona / giorno',
    'cal.more': 'altri',
    // esito prenotazione
    'bo.loading.title': 'Un attimo…', 'bo.loading.text': 'Stiamo elaborando la tua richiesta.',
    'bo.confirmed.title': 'Prenotazione confermata ✓', 'bo.confirmed.text': 'Ottimo! La tua prenotazione è confermata. Ti abbiamo inviato una email con i dettagli.',
    'bo.waitlisted.title': "Sei in lista d'attesa", 'bo.waitlisted.text': "Le date scelte sono al completo: sei in lista d'attesa. Ti avviseremo appena si libera un posto, rispettando l'ordine di arrivo.",
    'bo.cancelled.title': 'Prenotazione annullata', 'bo.cancelled.text': 'La tua prenotazione è stata annullata. Ci dispiace vederti andare — quando vuoi ripartire ci trovi qui.',
    'bo.pending.title': 'In attesa', 'bo.pending.text': 'Operazione registrata.',
    'bo.error.title': 'Ops', 'bo.error.text': 'Si è verificato un errore.', 'bo.invalid': 'Link non valido.',
    'bo.back.tour': 'Torna ai tour', 'bo.back.home': 'Home',
    // modulo iscrizioni (campi fissi)
    'if.nome': 'Nome', 'if.cognome': 'Cognome', 'if.phone': 'Numero di telefono', 'if.email': 'Email',
    'if.msg': 'Messaggio', 'if.msg.ph': 'Scrivici la tua richiesta...',
    'if.consent': 'Acconsento al trattamento dei miei dati personali',
    'if.submit': 'Invia richiesta', 'if.submitting': 'Invio…',
    'if.err': 'Invio non riuscito. Riprova o contattaci direttamente.',
  },
  en: {
    // nav
    'nav.home': 'Home', 'nav.storia': 'About', 'nav.tour': 'Tours', 'nav.gare': 'Races',
    'nav.iscrizioni': 'Membership', 'nav.contatti': 'Contact', 'nav.book': 'Book Now',
    // footer
    'footer.moto': 'Moto Club', 'footer.eventi': 'Events', 'footer.contatti': 'Contact',
    'footer.link.convenzioni': 'Partnerships', 'footer.link.sponsor': 'Sponsors',
    'footer.tagline': 'Adventure since 2020 · Made in Sardinia',
    'footer.privacy': 'Privacy Policy', 'footer.termini': 'Terms & Conditions', 'footer.login': 'Login',
    // page hero titoli / crumb
    'crumb.home': 'Home', 'crumb.prenotazione': 'Booking',
    'page.storia.title': 'About', 'page.tour.title': 'Tours', 'page.gare.title': 'Races',
    'page.iscrizioni.title': 'Membership', 'page.contatti.title': 'Contact',
    // tour page
    'tp.eyebrow': 'Enduro / Off-Road', 'tp.title': 'Choose your adventure',
    'tp.lead': 'Based in Olbia. Every tour is guided, with support and optional bike rental.',
    'tp.included': 'Included', 'tp.notIncluded': 'Not included', 'tp.book': 'Book this tour',
    'tp.none': 'Tours will be available soon. Contact us at {phone}.',
    'tp.prenota.eyebrow': 'Book the tour', 'tp.prenota.title': 'Choose dates\nand ride',
    'tp.prenota.lead': "Select the tour, the date and the number of people. We'll confirm availability and details by email.",
    'tp.meta.orario': 'Hours 9:00 — 16:30', 'tp.meta.min': 'Minimum {n} people', 'tp.meta.email': 'Confirmation by email',
    'tp.price.from': 'Starting from\nper person / day',
    'tp.price.note': 'Online you only pay the {deposit}% deposit to secure your spot. Free cancellation up to 3 weeks before. If the date is full you join the waiting list.',
    'tp.cta.eyebrow': 'Tailor-made routes', 'tp.cta.title': "Let's build\nyour tour",
    'tp.cta.text': 'Have a particular itinerary in mind? Tell us: we build a tailor-made tour for your group.',
    'tp.cta.phone': 'Call now',
    // booking form
    'bf.tour': 'Tour', 'bf.tour.ph': '— Select a tour —',
    'bf.date': 'Available date', 'bf.date.ph.pick': '— Select a date —',
    'bf.date.ph.none': 'No dates available — contact us', 'bf.date.ph.first': 'First choose a tour',
    'bf.seatsFree': 'spots left', 'bf.waitlist': 'waiting list',
    'bf.period': 'Choose your dates', 'bf.period.selectEnd': 'select the end date', 'bf.days': 'days',
    'bf.people': 'People', 'bf.people.min': 'Min', 'bf.people.max': 'max', 'bf.people.part': 'participants',
    'bf.level': 'Level', 'bf.level.1': 'Amateur', 'bf.level.2': 'Intermediate', 'bf.level.3': 'Advanced',
    'bf.name': 'First name', 'bf.surname': 'Last name', 'bf.email': 'Email', 'bf.phone': 'Phone',
    'bf.notes': 'Notes', 'bf.notes.ph': 'Experience, bike, special requests...',
    'bf.consent': 'I consent to the processing of my personal data',
    'bf.submit': 'Book now', 'bf.submitting': 'Sending…',
    'bf.err.period': 'Please select a period on the calendar.', 'bf.err.date': 'Please select an available date.',
    'bf.err.consent': 'You must consent to the processing of your data.',
    'bf.err.generic': 'An error occurred while submitting your booking.',
    'bf.result.title': 'Request sent ✓',
    'bf.result.waitlist': "The selected dates are full: by confirming from the email you'll join the waiting list and we'll notify you as soon as a spot frees up.",
    'bf.prev.duration': 'Duration', 'bf.prev.people': 'people',
    'bf.prev.total': 'Estimated total', 'bf.prev.deposit': 'Online deposit',
    'bf.prev.waitlistNote': 'Some days in the period are full: you may join the waiting list.',
    'bf.prev.estimate': 'Indicative estimate. The final quote will be confirmed.',
    // calendar
    'cal.legend.free': 'Available', 'cal.legend.tight': 'Waiting list',
    'cal.loading': 'Loading availability…', 'cal.seatsFree': 'spots left', 'cal.notAvailable': 'Not available',
    // showcase calendar (all packages)
    'cal.showcase.eyebrow': 'Calendar', 'cal.showcase.title': 'Package\navailability',
    'cal.showcase.lead': 'Browse the months: each day shows the scheduled packages. Click a day to book.',
    'cal.showcase.empty': 'No dates scheduled in the coming months. Contact us for a tailor-made tour.',
    'cal.detail.prompt': 'Select a highlighted day to see the available packages.',
    'cal.detail.on': 'Packages on', 'cal.pkg.full': 'Fully booked', 'cal.pkg.seats': 'spots',
    'cal.pkg.book': 'Book', 'cal.pkg.perday': 'per person / day',
    'cal.more': 'more',
    // booking outcome
    'bo.loading.title': 'One moment…', 'bo.loading.text': "We're processing your request.",
    'bo.confirmed.title': 'Booking confirmed ✓', 'bo.confirmed.text': "Great! Your booking is confirmed. We've sent you an email with the details.",
    'bo.waitlisted.title': "You're on the waiting list", 'bo.waitlisted.text': "The selected dates are full: you're on the waiting list. We'll notify you as soon as a spot frees up, in order of arrival.",
    'bo.cancelled.title': 'Booking cancelled', 'bo.cancelled.text': "Your booking has been cancelled. Sorry to see you go — whenever you want to ride again, we're here.",
    'bo.pending.title': 'Pending', 'bo.pending.text': 'Operation recorded.',
    'bo.error.title': 'Oops', 'bo.error.text': 'An error occurred.', 'bo.invalid': 'Invalid link.',
    'bo.back.tour': 'Back to tours', 'bo.back.home': 'Home',
    // membership form (fixed fields)
    'if.nome': 'First name', 'if.cognome': 'Last name', 'if.phone': 'Phone number', 'if.email': 'Email',
    'if.msg': 'Message', 'if.msg.ph': 'Write us your request...',
    'if.consent': 'I consent to the processing of my personal data',
    'if.submit': 'Send request', 'if.submitting': 'Sending…',
    'if.err': 'Submission failed. Please try again or contact us directly.',
  },
};

export const MONTHS: Record<Lang, string[]> = {
  it: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
  en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
};
export const WEEKDAYS: Record<Lang, string[]> = {
  it: ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'],
  en: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
};
export const DATE_LOCALE: Record<Lang, string> = { it: 'it-IT', en: 'en-GB' };

/** Hook per le etichette fisse dell'interfaccia nella lingua corrente. */
export function useUi() {
  const { lang } = useLang();
  const tr = (key: string) => UI[lang][key] ?? UI.it[key] ?? key;
  return { lang, tr, months: MONTHS[lang], weekdays: WEEKDAYS[lang], dateLocale: DATE_LOCALE[lang] };
}
